import './CSS/Title.css';
function Title () {
    return (
        <div >
            <p class="align-middle titlesize" id="tanyaintro">I'm Tanya.</p>
              <span id="jobtitle">A Front - End Developer</span>
             <p id="passionintro"> with a passion for design.</p>
        </div>
    );
  }
 
  export default Title;
  